module.exports = {"630122001":"康川街道","630122100":"鲁沙尔镇","630122101":"西堡镇","630122102":"上新庄镇","630122103":"田家寨镇","630122104":"甘河滩镇","630122105":"共和镇","630122106":"多巴镇","630122107":"拦隆口镇","630122108":"上五庄镇","630122109":"李家山镇","630122200":"群加乡","630122201":"土门关乡","630122202":"汉东乡","630122203":"大才乡","630122204":"海子沟乡","630122400":"甘河工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630122.json
// module id = 2771
// module chunks = 0